<template>
    <div class="">
        <div class="mb-4">
            <label for="area-code">Area Code</label>
            <div class="flex">
                <jet-input type="text" name="Area Code" placeholder="Area Code" id="area-code" v-model="areaCode"></jet-input>
                <jet-button class="ml-4" @click="getAvailableLocalNumbers" :disabled="searchingForNumbers">Search</jet-button>
            </div>
        </div>
        <div class="flex bg-gray-100 p-2 font-bold">
            <div class="w-6/12">Number</div>
            <div class="w-2/12 text-center">Region</div>
            <div class="w-2/12 text-center">SMS</div>
            <div class="w-2/12 text-center">MMS</div>
        </div>
        <div class="flex flex-wrap justify-around h-96 overflow-scroll">
            <div class="flex items-center" v-if="searchStatus === 'complete' && !availableNumbers.length">
              No available numbers for that area code have been found. Please try another search.
            </div>

            <div class="flex items-center" v-if="searchStatus === 'error' && !availableNumbers.length">
              An error occurred when searching for available numbers. Please try again.
            </div>

            <div class="flex items-center" v-if="searchStatus === null">
              Please enter an area code above and press search to find a number.
            </div>

            <div
                class="py-1 border-b w-full transition-colors duration-150 flex items-center"
                v-for="(number, key) in availableNumbers"
                :class="{
                    'text-white bg-blue-100 text-blue-700 selected':
                        number.phoneNumber === selectedNumber
                }"
            >
                <div class="w-6/12 relative items-center flex">
                    <div
                        class="circle-select transition-colors duration-150"
                    ></div>
                    <input
                        type="radio"
                        class="invisible absolute pointer-events-none"
                        :key="number.phoneNumber"
                        name="available-number"
                        :id="'phone_number_' + key"
                        :value="number.phoneNumber"
                        v-on:input="$emit('update:modelValue', availableNumbers[key])"
                        v-model="selectedNumber"
                    />
                    <label
                        :for="'phone_number_' + key"
                        class="block p-2 cursor-pointer font-normal w-full -ml-6 pl-8"
                    >{{ number.friendlyName }}</label
                    >
                </div>
                <div class="w-2/12 text-center">{{ number.isoCountry }}</div>
                <div class="w-2/12 text-center">
                    <font-awesome-icon
                        :icon="['far', 'check']"
                    ></font-awesome-icon>
                </div>
                <div class="w-2/12 text-center">
                    <font-awesome-icon
                        :icon="['far', 'check']"
                    ></font-awesome-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import JetButton from "../Jetstream/Button";
import axios from "axios";
import Label from "../Jetstream/Label";

export default {
    components: {Label, JetButton},
    emits: ['update:modelValue'],
    mounted() {
        // this.getAvailableTollFreeNumbers();
    },
    data() {
        return {
            areaCode: "",
            availableNumbers: [],
            searchingForNumbers: false,
            selectedNumber: null,
            searchStatus: null,
        };
    },
    computed: {},
    props: {},
    methods: {
        getAvailableLocalNumbers() {
            let vm = this;
            vm.searchingForNumbers = true;
            vm.selectedNumber = null;
            vm.$emit("update:modelValue", null);

            axios
                .post(route("availableNumbers.local"), {
                    area_code: vm.areaCode
                })
                .then(function(res) {
                    vm.availableNumbers = res.data;

                    // default select the first returned phone number if exists
                    if ( res.data.length ) {
                      vm.selectedNumber = vm.availableNumbers[0].phoneNumber;
                      vm.$emit("update:modelValue", vm.availableNumbers[0]);
                    }

                    vm.searchingForNumbers = false;
                    vm.searchStatus = 'complete';
                })
                .catch(function(err) {
                    console.log(err);
                    vm.searchingForNumbers = false;
                    vm.searchStatus = 'error';
                });
        },
        getAvailableTollFreeNumbers() {
            let vm = this;
            vm.searchingForNumbers = true;

            axios
                .post(route("availableNumbers.tollFree"))
                .then(function(res) {
                    vm.availableNumbers = res.data;
                    // default select the first returned phone number
                    vm.selectedNumber = vm.availableNumbers[0].phoneNumber;
                    vm.$emit("update:modelValue", vm.availableNumbers[0]);
                    vm.searchingForNumbers = false;
                })
                .catch(function(err) {
                    console.log(err);
                    vm.searchingForNumbers = false;
                });
        }
    }
};
</script>

<style scoped>
.circle-select {
    @apply border border-gray-500 ml-4;

    width: 12px;
    height: 12px;
    border-radius: 50%;
}

.selected .circle-select {
    @apply bg-blue-200 border-blue-700;
}
</style>
